import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import useOutsideClick from "hooks/click-outside-hook";

interface NotificationData {
  title: string;
  description: string;
}

interface Props {
  isOpen: boolean;
  onClose: () => void;
  content: NotificationData | null;
}

const NotificationModal: React.FC<Props> = ({ isOpen, onClose, content }) => {
  const modalRef = useOutsideClick(onClose);

  if (!isOpen || !content) return null;

  return (
    <div
      className={`fixed z-50 inset-0 bg-black bg-opacity-50 flex justify-center items-center transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <div
        ref={modalRef}
        className={`relative bg-white p-6 rounded-lg shadow-lg max-h-fit overflow-y-auto sm:w-[500px] w-1/2 transform transition-transform duration-300 ${
          isOpen ? "scale-100" : "scale-95"
        }`}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 transition"
        >
          <AiOutlineClose size={20} />
        </button>

        {/* Modal Content */}
        <h2 className="text-xl font-bold mb-4 text-center">{content.title}</h2>
        <p className="text-gray-700">{content.description}</p>
      </div>
    </div>
  );
};

export default NotificationModal;
